export default {
    en: {
        contact_support: 'Contact support',
        current_language: 'English',
        confirm: 'Confirm',
        back: 'Back',
        yes: 'yes',
        no: 'no',

        meta_data: {
            profile: {
                title: 'Profile'
            },
            login: {
                title: 'Login'
            },
            dashboard: {
                title: 'Performance Board'
            },
            reset_password: {
                title: 'Reset password'
            },
        },

        login: {
            email: 'E-mail',
            password: 'Password',
            login: 'Login',
            reset_password: 'Reset password',
            checking: 'Checking'
        },

        reset_password: {
            request_new: 'Request a new',
            password: 'Password',
            email: 'E-mail',
            send_reset_mail: 'Send password reset mail',
            new_password: 'New password',
            new_password_repeat: 'Repeat new password',
            set_new_password: 'Set new password',
        },

        request: {
            error: 'There was an error. Please try again later or contact support',
            success_request: 'Your request has been successfully sent',
            success_data: 'Your data has been successfully saved',
        },

        validation: {
            required: 'This field is required',
            wallet_address: 'Please enter a valid wallet address',
            credentials: 'E-mail and/or password incorrect',
            number: 'Please enter a number',
            number_above_0: 'Please enter a number greater than 0',
            number_less_9999: 'Please enter a number less than 9999',
            email: {
                required: 'E-mail is a required field',
                valid: 'Please use a valid e-mail'
            },
            password: {
                required: 'Password is a required field',
                match: 'Passwords must match',
                requirements: 'Must contain at least 8 characters, 1 uppercase, 1 special Character, and 1 number',
                wrong: 'Wrong password'
            }
        },

        navigation: {
            logout: 'Logout',
            profile: 'My profile'
        },

        dashboard: {
            welcome_message: 'Welcome back',
            your_orders: 'Your orders',
            order_nr: 'Order no.',
            estimated_delivery: 'Estimated delivery',
            estimated_delivery_info: 'Thank you for your order! Follow the status of your order here. As soon as we have received the devices, we will put them through their paces ("testing") for quality assurance reasons and then send them to you - unless you have arranged a collection on site with us. You can then collect your order from us.',
            delivery_date_unknown: 'Delivery date unknown',
            delivery_state: {
                cash_receipt: 'Cash receipt',
                shipped_to_us: 'Device(s) on the way to us',
                testing: 'Testing',
                dispatched: 'Dispatched or ready for collection',
                delivered: 'Delivered or collected'
            },
            order_date: 'Order date',
            hosting: 'Hosting',
            order_amount: 'Units',
            price_per_unit: 'Price per unit',
            subtotal: 'Subtotal',
            tax: 'VAT',
            total: 'Total',
            your_hosting: 'Your hosting',
            your_hosting_text: 'Please move on, there is nothing to see here (yet)'
        },

        profile: {
            my_profile: 'My profile',
            name: 'Name',
            first_name: 'Firstname',
            wallet: 'Wallet for withdrawals',
            zip: 'Postal code',
            city: 'City',
            street_number: 'Street, house number',
            zip_city: 'Postal code, city',
            country: 'Country',
            change_password: 'Change password',
            edit_info: 'Edit info'
        },

    },
    de: {
        contact_support: 'Support kontaktieren',
        current_language: 'Deutsch',
        confirm: 'Bestätigen',
        back: 'Zurück',
        yes: 'Ja',
        no: 'Nein',

        meta_data: {
            profile: {
                title: 'Profil'
            },
            login: {
                title: 'Einloggen'
            },
            dashboard: {
                title: 'Performance Board'
            },
            reset_password: {
                title: 'Passwort zurücksetzen'
            },
        },

        login: {
            email: 'E-Mail',
            password: 'Passwort',
            login: 'Einloggen',
            reset_password: 'Passwort zurücksetzen',
            checking: 'Prüfen'
        },

        reset_password: {
            request_new: 'Anfrage neues',
            password: 'Passwort',
            email: 'E-Mail',
            send_reset_mail: 'E-Mail zum Zurücksetzen senden',
            new_password: 'Neues Passwort',
            new_password_repeat: 'Passwort wiederholen',
            set_new_password: 'Neues Passwort setzen',
        },

        request: {
            error: 'Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal oder kontaktiere unseren Support',
            success_data: 'Deine Daten wurden erfolgreich gespeichert',
        },

        validation: {
            required: 'Die ist ein Pflichtfeld',
            credentials: 'E-Mail und/oder Password falsch',
            number: 'Bitte eine Zahl eingeben',
            number_above_0: 'Bitte geben Sie eine Zahl größer als 0 ein',
            number_less_9999: 'Bitte geben Sie eine Zahl kleiner als 9999 ein.',
            wallet_address: 'Bitte gib eine gültige Wallet ein',
            email: {
                required: 'E-Mail ist ein Pflichtfeld',
                valid: 'Ungültige E-Mail'
            },
            password: {
                required: 'Passwort ist ein Pflichtfeld',
                match: 'Passwörter müssen übereinstimmen',
                requirements: 'Muss mindestens 8 Zeichen enthalten, 1 Großbuchstabe, 1 Sonderzeichen und 1 Zahl',
                wrong: 'Falsches Passwort'
            }
        },

        navigation: {
            logout: 'Ausloggen',
            profile: 'Mein Profil'
        },

        dashboard: {
            welcome_message: 'Willkommen zurück',
            your_orders: 'Deine Bestellungen',
            order_nr: 'Bestell-Nr.',
            estimated_delivery: 'Voraussichtliche Zustellung',
            estimated_delivery_info: 'Vielen Dank für Deine Bestellung! Verfolge hier den Status Deiner Bestellung. Sobald die Geräte bei uns eingetroffen sind, werden wir diese aus Gründen der Qualitätssicherung auf Herz und Nieren prüfen ("Testing") und dir im Anschluss zusenden - es sei denn, Du hast mit uns eine Abholung vor Ort vereinbart. Dann kannst Du Deine Bestellung bei uns abholen.',
            delivery_date_unknown: 'Lieferdatum unbekannt',
            delivery_state: {
                cash_receipt: 'Geldeingang',
                shipped_to_us: 'Gerät(e) auf dem Weg zu uns',
                testing: 'Testing',
                dispatched: 'Versendet bzw. abholbereit',
                delivered: 'Zugestellt bzw. abgeholt'
            },
            order_date: 'Bestelldatum',
            hosting: 'Hosting',
            order_amount: 'Einheiten',
            price_per_unit: 'Preis pro Einheit',
            subtotal: 'Zwischensumme',
            tax: 'MwSt',
            total: 'Gesamtsumme',
            your_hosting: 'Dein Hosting',
            your_hosting_text: 'Bitte weitergehen, hier gibt es (noch) nichts zu sehen'
        },

        profile: {
            my_profile: 'Mein Profil',
            name: 'Name',
            first_name: 'Vorname',
            zip: 'Postleitzahl',
            city: 'Stadt',
            wallet: 'Wallet für Auszahlungen',
            street_number: 'Straße, Hausnummer',
            zip_city: 'Postleitzahl, Stadt',
            country: 'Land',
            change_password: 'Passwort ändern',
            edit_info: 'Infos bearbeiten'
        },
    }
    
}